import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import ProductEntity from '@/entities/api/products/products'

interface ProductsState {
	products: ProductEntity[]
	selectProduct: ProductEntity | null
}

const initialState: ProductsState = {
	products: [],
	selectProduct: null,
}

const productsSlice = createSlice({
	name: 'products',
	initialState,
	reducers: {
		setProductsFn: (state, action: PayloadAction<ProductEntity[]>) => {
			state.products = action.payload
		},
		setSelectProductFn: (state, action: PayloadAction<ProductEntity>) => {
			state.selectProduct = action.payload
		},
		addProductFn: (state, action: PayloadAction<ProductEntity>) => {
			const exists = state.products.some((p) => p._id === action.payload._id)
			if (!exists) state.products.push(action.payload)
		},
		updateProductFn: (state, action: PayloadAction<Partial<ProductEntity>>) => {
			const idx = state.products.findIndex((p) => p._id === action.payload._id)
			if (idx !== -1) {
				state.products[idx] = { ...state.products[idx], ...action.payload }
			}
		},
		updateSelectProductFn: (state, action: PayloadAction<Partial<ProductEntity>>) => {
			if (
				state.selectProduct &&
				state.selectProduct._id === action.payload._id
			) {
				state.selectProduct = { ...state.selectProduct, ...action.payload }
			}
		},
		deleteProductFn: (state, action: PayloadAction<string>) => {
			state.products = state.products.filter((p) => p._id !== action.payload)
		},
		clearProductsFn: (state) => {
			state.products = []
		},
	},
})

export const {
	setProductsFn,
	setSelectProductFn,
	addProductFn,
	updateProductFn,
	updateSelectProductFn,
	deleteProductFn,
	clearProductsFn,
} = productsSlice.actions

export default productsSlice.reducer
